function salesRepLocator() {

    if ( $('#sales-rep-form').length ) {

        const formatPhoneNumber = (phone) => phone
        .replace(/\D/g, '')
        .replace(/(\d*)(\d{3})(\d{3})(\d{4})$/, (s, a, b, c, d) => `+${a} (${b}) ${c}-${d}`)
        .replace(/\+(1\b|\s)\s*/, '');

        const $salesRepHeading = $('.sales-rep-heading');

        $('#sales-rep-form').submit(function(e) {
            e.preventDefault();
            const zip = $('input[name=ajxZipCode]').val(),
                  radius = $('select[name=ajxSearchRadius]').val();

            fetch(`https://pivotbio.prvsn.net/api/locator/search?radius=${radius}&zipCode=${zip}`, {
                method: 'GET'
            })
            .then(response => response.json())
            .then(result => {
                const columns = result.COLUMNS;
                const data = result.DATA;

                const json = data.map((row) => {
                    const obj = {};
                    row.forEach((item, index) => {
                        obj[columns[index]] = item;
                    });
                    return obj;
                });

                let markup;

                $('.search-radius', $salesRepHeading).text(radius);
                $('.search-zip', $salesRepHeading).text(zip);
                $('.search-results-num', $salesRepHeading).text(json.length);
                $salesRepHeading.show();

                if (json[0].DISPLAY_NAME == '') {
                    markup = `
                        <div class="sales-rep__result">
                            <div class="sales-rep__image no--result">
                                <img src="${theme_vars.theme_dir}/assets/img/no-result.svg" alt="No Results" />
                            </div>
                            <div class="sales-rep__details">
                                <p>We're sorry, no results were located within <strong>${radius}</strong> miles of <strong>${zip}</strong>. Please adjust your search or contact us below.</p>
                            </div>
                            <a class="btn btn--arrow" href="/contact-us">Contact Us</a>
                        </div>
                    `
                } else {
                    for (let i in json) {
                        markup = `
                            <div class="sales-rep__result" data-name="${json[i].DISPLAY_NAME}" data-title="${json[i].TITLE}" data-location="${json[i].CITY}, ${json[i].STATE}" data-phone="${json[i].PHONE}" data-email="${json[i].EMAIL}">
                                <div class="sales-rep__image${json[i].PHOTO.includes('COLOR_700x629') ? ' no--result' : ''}">
                                    <img src="${json[i].PHOTO.includes('COLOR_700x629') ? theme_vars.theme_dir + '/assets/img/no-result.svg' : json[i].PHOTO}" alt="${json[i].DISPLAY_NAME}" />
                                </div>
                                <div class="sales-rep__details">
                                    <h4>${json[i].DISPLAY_NAME}</h4>
                                    <span class="sales-rep__title">${json[i].TITLE}</span>
                                    <span class="sales-rep__location">${json[i].CITY}, ${json[i].STATE}</span>
                                </div>
                                <a class="btn btn--arrow sales-rep-contact" href="#">Contact Information</a>
                            </div>
                        `;
                    }
                }

                document.querySelector('.sales-rep__cont').innerHTML = markup;
            })
            .catch(error => {
                console.error('Error:', error);
            });
        });

        $(document).on('click', '.sales-rep-contact', function(e) {
            e.preventDefault();
            const $this = $(this),
                  $cont = $this.closest('.sales-rep__result'),
                  personName = $cont.attr('data-name'),
                  personTitle = $cont.attr('data-title'),
                  personImage = $('.sales-rep__image img', $cont).attr('src'),
                  personLocation = $cont.attr('data-location'),
                  personEmail = $cont.attr('data-email'),
                  personPhone = $cont.attr('data-phone');


            const modalHTML = `
                <div class="bio-modal">
                    <div class="bio-modal__left">
                        <img src="${personImage}" alt="${personName}" />
                    </div>
                    <div class="bio-modal__right">
                        <h2 class="heading-5">${personName}</h2>
                        <h3 class="heading-7">${personTitle}</h3>
                        <div class="rep-contact-info">
                            <span>Location: ${personLocation}</span>
                            <span>Email: ${personEmail}</span>
                            <span>Phone: <a href="tel:${personPhone}" target="_blank">${formatPhoneNumber(personPhone)}</a></span>
                            <a class="btn" href="mailto:${personEmail}" target="_blank">Email ${personName}</a>
                        </div>
                    </div>
                </div>
            `
            $('.modal-window__target').html(modalHTML);
            openModal();
        });

        $('a.download-headshot').click(function(e) {
            e.preventDefault();
        });
    }

}
